import { FormsModule } from './../forms/forms.module';
import { EmailDialogComponent } from './components/email-dialog/email-dialog.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { MaterialModule } from '../../material/material.module';
import { MemberDetailComponent } from './components/member-detail/member-detail.component';
import { MemberInformationComponent } from './components/member-information/member-information.component';
import { NotificationDialogComponent } from './components/notification-dialog/notification-dialog.component';
import { NotificationListComponent } from './components/notification-list/notification-list.component';
import { GlpCommonModule } from 'src/app/glp-common/glp-common.module';
import { AlertDialogComponent } from 'src/app/glp-common/components/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from 'src/app/glp-common/components/confirm-dialog/confirm-dialog.component';
import { MembersListModule } from './components/members-list/members-list.module';
import { GroupleaderlistComponent } from './components/groupleaderlist/groupleaderlist.component';
import { DeniedDialogComponent } from 'src/app/glp-common/components/denied-dialog/denied-dialog.component';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [HomeComponent, MemberDetailComponent, MemberInformationComponent, NotificationListComponent, GroupleaderlistComponent],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    GlpCommonModule,
    MembersListModule,
    MatIconModule
  ],
  entryComponents:[MemberDetailComponent, MemberInformationComponent, AlertDialogComponent, DeniedDialogComponent, ConfirmDialogComponent, NotificationDialogComponent, EmailDialogComponent],
  exports:[NotificationListComponent]
})
export class HomeModule { }
